import React, { useEffect, useState } from 'react';
import { ModelDefinitionDto } from '../../models/APIModels';
import paginationUtils from '../../Utils/paginationUtils';
import { SEARCH_MODEL_DEFAULT_PAGINATION } from '../../constants';
import { Button, Chip, Grid, Pagination, Typography } from '@mui/material';
import { cloneDeep } from 'lodash';
import ItemContent from '../ItemContent';
import SearchModelInput from '../SearchModelInput';
import ListViewSkeleton from '../Loaders/ListViewSkeleton';
import Loader from '../Loader';

interface IProps {
  items: ModelDefinitionDto[];
  doSearch: (searchKeyWord, pagination) => void;
  isLoading: boolean;
  paginationDetail: any;
  paginationChange: (pagination) => void;
  searchInputPlaceHolder?: string;
  showSaerchInput?: boolean;
  hidePagination?: boolean;
  searchContent?: string;
  onActionClick?: (item, type) => void;
  itemKey?: string;
  searchTerm?: string;
  searchType?: string;
  hideSearchTypeMenu?: boolean;
  showFilter?: boolean;
}

const SearchContent = ({
  items,
  doSearch,
  isLoading,
  paginationDetail,
  paginationChange,
  searchInputPlaceHolder = 'Search for a model ...',
  showSaerchInput = true,
  hidePagination = false,
  searchContent = 'mymodels',
  onActionClick = null,
  itemKey = 'modelId',
  searchTerm = '',
  searchType = 'ai',
  hideSearchTypeMenu = false,
  showFilter = false,
}: IProps) => {
  const [searchKeyWord, setSearchKeyWord] = useState(searchTerm);
  // const [type, setType] = useState(searchType);
  const [paginationSummary, setPaginationSummary] = useState(
    paginationUtils.getPaginationSummary(paginationDetail, paginationDetail.totalItems)
  );
  const onSearchKeyWordChange = (value) => {
    setSearchKeyWord(value);
  };

  const onSearch = (value) => {
    setTimeout(() => {
      doSearch(value, SEARCH_MODEL_DEFAULT_PAGINATION);
    }, 0);
  };
  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    let paginationDetails = cloneDeep(paginationDetail);
    if (value !== paginationDetails.page) {
      paginationDetails.page = value;
      if (paginationChange) paginationChange(paginationDetails);
    }
  };

  useEffect(() => {
    if (!paginationDetail) paginationDetail = SEARCH_MODEL_DEFAULT_PAGINATION;
    setPaginationSummary(paginationUtils.getPaginationSummary(paginationDetail, paginationDetail.totalItems));
  }, [paginationDetail]);

  useEffect(() => {
    setSearchKeyWord(searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    // console.log('move page to top', window.scrollY, searchType)
    // window.scrollTo(0, 0);
  }, []);

  return (
    <div className="search-container">
      {/* User entered search query for models..... */}
      {showSaerchInput && (
        <>
          <Grid container direction="row" alignItems="center" justifyContent="center">
            <Grid item xs={12}>
              <SearchModelInput
                onSearch={(searchTerm) => onSearch(searchTerm)}
                defaultValue={searchKeyWord}
                onChange={(value) => onSearchKeyWordChange(value)}
                hideSearchTypeMenu={hideSearchTypeMenu}
                searchType={searchType}
                searchInputPlaceHolder={searchInputPlaceHolder}
                size="medium"
                showFilter={showFilter}
                searchContent={searchContent}
              />
            </Grid>
          </Grid>
        </>
      )}

      {/* Search result for model..... */}
      {isLoading && <ListViewSkeleton listLength={10}/>}

      {!isLoading && (
        <>
          <div className="model-list-container">
            {items &&
              items.length > 0 &&
              items.map((item) => (
                <React.Fragment key={item[itemKey]}>
                  <ItemContent searchItem={item} type={searchContent} itemKey={item[itemKey]} onActionClick={onActionClick} />
                </React.Fragment>
              ))}
          </div>

          {/* Displaying paginated search results for models..... */}
          {!hidePagination && (
            <div className="pagination-container">
              {paginationSummary && !isLoading && (
                <div className="pagination-stats">
                  Showing {paginationSummary.from} &mdash; {paginationSummary.to} of {paginationSummary.total}
                </div>
              )}
              <div className="pagination-steps">
                {!isLoading && (
                  <Pagination
                    className="pagination-steps"
                    size="small"
                    siblingCount={0}
                    boundaryCount={1}
                    count={paginationDetail.pages}
                    page={paginationDetail.page}
                    variant="outlined"
                    shape="rounded"
                    color="primary"
                    onChange={handlePageChange}
                    sx={{ marginBottom: '20px !important' }}
                  />
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SearchContent;
